import { lazy, Suspense } from 'react';
import { Callout } from '@/shared/ui';
import styles from './FormNote.module.css';

const NoteMarkdown = lazy(() => import('./NoteMarkdown'));

export const FormNote: React.FC<{ title: string; content: string }> = ({ title, content }) => (
  <Callout tone="info" title={title}>
    <Suspense fallback={<p className={styles.plain}>{content}</p>}>
      <NoteMarkdown text={content} />
    </Suspense>
  </Callout>
);
